import { Link } from '@tanstack/react-router';
import { T } from 'gt-react';
import { Action, Subject } from '@erp/authz';
import { Badge } from 'src/components/ui/badge';
import { useCan } from 'src/hooks/useCan';
import { useNamespaces } from 'src/api/rpc/hooks/namespaces/useNamespaces';

export function NamespaceBadge({
  namespaceId,
}: {
  namespaceId: string | null | undefined;
}) {
  const { data: namespaces } = useNamespaces();
  const [canReadNamespaces] = useCan(Action.Read, Subject.Namespace);
  const namespace = namespaceId
    ? namespaces?.find((entry) => entry.id === namespaceId)
    : undefined;

  if (!namespaceId) {
    return (
      <span className="text-sm text-muted-foreground">
        <T context="badge when a workflow or agent has no namespace">
          No namespace
        </T>
      </span>
    );
  }

  const label = namespace
    ? `${namespace.name} (${namespace.key})`
    : namespaceId;

  if (!canReadNamespaces) {
    return (
      <Badge variant="outline" className="font-normal">
        {label}
      </Badge>
    );
  }

  return (
    <Link
      to="/namespaces/$namespaceId"
      params={{ namespaceId }}
      className="inline-flex"
    >
      <Badge
        variant="outline"
        className="font-normal hover:bg-muted transition-colors"
      >
        {label}
      </Badge>
    </Link>
  );
}
